import { postData } from '@/utils/request';
import {
  GetJumpCfgReq,
  GetJumpCfgRes,
  GenerateUrlReq,
  GenerateUrlRes,
} from './../interface/openWeapp';

/**查询单条微信短地址配置 */
export const getJumpCfg = (data: GetJumpCfgReq) => {
  return postData<GetJumpCfgRes, GetJumpCfgReq>(
    '/activity/wxapp/applet/getJumpCfg',
    data
  );
};

/**获取微信URL-Link(海底捞会员小程序) */
export const generateMemberUrl = (data: GenerateUrlReq) => {
  return postData<GenerateUrlRes, GenerateUrlReq>(
    '/CaterWeixin/generateUrl',
    data
  );
};

/**获取微信URL-Link(商城小程序) */
export const generateMallUrl = (data: GenerateUrlReq) => {
  return postData<GenerateUrlRes, GenerateUrlReq>(
    '/mallapi/aggregation/push/generateUrl',
    data
  );
};

export default {
  getJumpCfg,
  generateMemberUrl,
};
